// react
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../assets/css/nestedList.css";
const TermsOfUseModal = (props) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Modal
        show={props.showModal}
        onHide={props.hideModal}
        size="lg"
        scrollable={true}
        id="ItemEditModal"
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Header onHide={props.hideModal} closeButton>
          {t("Terms of Use")}
        </Modal.Header>
        <Modal.Body>
          <div className="nestedList">
            <ol>
              <li>
                <b> {t("General Information")}</b>
                <ol>
                  <li>
                    {t(
                      "Line Up Handels GmbH (hereinafter referred to as “the Supplier”) maps the complete processes along the supply chain from the procurement markets, primarily in Asia, to Germany for its customers. It manages production, quality control, import processing, loading, delivery, order picking and more."
                    )}
                  </li>
                  <li>
                    {t(
                      "The provider's offer is aimed exclusively at entrepreneurs (within the meaning of Section 14 (1) BGB, i.e. natural or legal persons or partnerships with legal capacity who are acting in the exercise of their commercial or independent professional activity when concluding the transaction) as well as legal persons under public law and special funds under public law. The user confirms this with his registration."
                    )}
                  </li>
                  <li>
                    {t(
                      "The Provider provides a service on the Internet under the name Line Up Dashboard (hereinafter referred to as “the Service”) for the digital mapping of the entire supply chain. The Service currently consists of the functions listed in Section 2, which the Provider will adapt and expand from time to time."
                    )}
                  </li>
                  <li>
                    {t(
                      "The Provider offers the User the opportunity to use the Service free of charge in accordance with these Terms of Use. A legally binding agreement between the Provider and the User comes into effect when the User uses the Service. Use of the Service without acceptance of these Terms of Use or in a manner or to an extent not expressly permitted in these Terms of Use is prohibited. The user shall bear any charges incurred through the individual use of the service, in particular connection charges for access by the user's terminal device to the provider's server."
                    )}
                  </li>
                  <li>
                    {t(
                      "The Provider is entitled to amend and adapt these Terms of Use from time to time, provided that the User is not disadvantaged by the amendments contrary to good faith. The Provider shall make these changes accessible in the Service and inform the User of the changes by e-mail to the address stored in the User profile. The provider will also inform the user when the change will take effect, usually four weeks after informing the user. If the user continues to use the services after the changes take effect, this shall be deemed acceptance of the amended terms of use. If the User objects to the amendment to the Terms of Use, the Provider shall be entitled to terminate the contract of use without notice as of the date on which the amended Terms of Use come into effect."
                    )}
                  </li>
                </ol>
              </li>
              <li>
                <b>{t("Functions of the service and their use")}</b>

                <ol>
                  <li>
                    {t("Order management")}
                    <br />
                    {t(
                      "Creation and processing of orders and purchase orders together with the display of open and past orders and purchase orders as well as the associated documents. An inquiry does not constitute a binding offer to purchase the item in question. Rather, the provider will first check the inquiry and then submit a binding offer to the user in a letter of offer. This offer shall only be deemed accepted as soon as the customer expressly declares acceptance in text form (e.g. letter, fax, e-mail)."
                    )}
                  </li>
                  <li>
                    {t("Document management")}
                    <br />
                    {t(
                      "Digital archive for orders, purchase orders, delivery bills, invoices, quality reports and more."
                    )}
                  </li>
                  <li>
                    {t("Container/order tracking")} <br />
                    {t(
                      "Real-time location data of orders is determined via AIS Data (Automated Identification System)."
                    )}
                    <br />
                    {t(
                      "The data shown is obtained from third-party providers. The provider assumes no liability for the completeness and accuracy of the data. In particular, displayed expected arrival dates do not represent binding delivery dates."
                    )}
                  </li>
                  <li>
                    {t("E-mail notifications")} <br />
                    {t(
                      "The user is optionally informed automatically by e-mail about changes or important events. The user can make the relevant settings themselves in their account."
                    )}
                  </li>
                  <li>
                    {t("Analytics")} <br />
                    {t(
                      "Evaluation of supply chain management through historical data, key performance indicators and several tools."
                    )}
                  </li>
                  <li>
                    {t("Real-time data")} <br />
                    {t(
                      "Real-time data on material prices, exchange rates, location data and more."
                    )}
                    <br />
                    {t(
                      "The data presented is sourced from third-party providers. The provider assumes no liability for the completeness and accuracy of the data."
                    )}
                  </li>
                </ol>
              </li>
              <li>
                <b>{t("Obligations of the user")}</b>
                <ol>
                  <li>
                    {t(
                      "During the registration process, the user is obliged to provide all required minimum personal details truthfully and completely and to keep his/her data up to date at all times. The minimum information required for registration and the creation of a user account is first and last name, company name, e-mail address and password. If the user voluntarily provides additional data, this must also be correct. Each user is solely responsible for the accuracy and content of personal information, in particular for the accuracy and functionality of the e-mail address provided."
                    )}
                  </li>
                  <li>
                    {t(
                      "The user is obliged to keep his password secret, store it securely and not make it accessible to third parties. If the password becomes known to third parties, the user must inform the provider immediately by e-mail or in writing so that the old password can be blocked and a new password can be assigned. The user is not authorized to make his user account available to third parties. If the user violates these regulations, he shall be responsible for all activities carried out under his user account, both to the provider and to third parties."
                    )}
                  </li>
                  <li>
                    {t(
                      "The User is expressly prohibited from the following activities:"
                    )}
                    <ol>
                      <li>
                        {t(
                          "Using the Service in any way other than that specified by the user interface provided by the Provider, in particular by accessing the Service or parts thereof through scripts, bots or similar."
                        )}
                      </li>
                      <li>
                        {t(
                          "The disruption, impairment, alteration, interruption, modification of provider content, user activities and user content."
                        )}
                      </li>
                      <li>
                        {t(
                          "Any measures that lead to excessive system loads or system malfunctions. This includes such unauthorized user activities that have the aim or potential to disrupt or destroy the functions of computer software or hardware or telecommunications equipment by transmitting viruses, worms, spyware, Trojan horses or other harmful computer code."
                        )}
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                <b>{t("Data protection")}</b>
                <br />
                <p>
                  {t(
                    "The provider will respect the privacy of the user and ensure the protection of personal data. Information on the processing of the user's personal data and the rights to which the user is entitled as a data subject can be found in the separate data protection declaration."
                  )}
                </p>
              </li>
              <li>
                <b>{t("Copyrights and other intellectual property rights")}</b>
                <ol>
                  <li>
                    {t(
                      "The Provider grants the User the non-exclusive, non-transferable and limited right to use copyrights, trademarks, titles, patents, utility models and registered designs as well as other rights to computer programs, database works, databases, photos, graphics, designs, logos, texts and other data of the Provider (collectively, the “Provider Content”) within the scope of the intended use of the Service. Any use of the Provider Content outside of these Terms of Use is excluded. Insofar as the Service makes use of corresponding third-party content (e.g. software libraries), the Provider shall ensure that either the Provider itself or the owner of the corresponding rights grants the User a corresponding right of use."
                    )}
                  </li>
                  <li>
                    {t(
                      "The User must ensure that he does not infringe any third-party rights through his use of the Service, in particular by uploading content and files to the Service. In particular, the User must ensure that he does not infringe any copyrights, rights to property including intellectual property, personal rights, competition rights, data protection rights or other rights to which a third party is entitled."
                    )}
                    <br />
                    {t(
                      "The User shall indemnify the Provider against all obligations, liabilities and costs incurred by the Provider as a result of third parties taking action against the Provider due to a breach of this Section 5.2."
                    )}
                  </li>
                </ol>
              </li>
              <li>
                <b>{t("Availability of the service")}</b>
                <ol>
                  <li>
                    {t(
                      "The Provider reserves the right to discontinue the operation of the Service temporarily or permanently, partially or completely. In this case, the Provider shall announce this at least one month in advance on the Service website."
                    )}
                  </li>
                  <li>
                    {t(
                      "It is at the Provider's discretion how it designs the Service and its functions. It may change, expand or restrict this at any time."
                    )}
                  </li>
                  <li>
                    {t(
                      "The Provider points out that events beyond its control, e.g. power failures, hacker attacks or telecommunications line failures, may lead to the unavailability of the Service. It is also possible that the service may be temporarily unavailable due to maintenance work or updates."
                    )}
                  </li>
                  <li>
                    {t(
                      "The User is aware that the capacity of the Service and its Internet connection are limited and that this may result in the transmission, processing or presentation of data not being possible in whole or in part or not being possible in good time. The Service or individual functions thereof may also be temporarily or permanently restricted, disrupted or no longer available at all."
                    )}
                  </li>
                  <li>
                    {t(
                      "In the event of restrictions, settings, changes or failures of the usage options as described in this section, the user shall not be entitled to any claims for damages, reimbursement of losses or similar against the provider."
                    )}
                  </li>
                </ol>
              </li>

              <li>
                <b>{t("Warranty / Liability")}</b>
                <ol>
                  <li>
                    {t(
                      "The Provider shall develop and operate the Service with due care and attention to the state of the art. It provides the Service as it is offered in each case and in no way assumes any guarantees or warranties that the Service"
                    )}
                    <ol>
                      <li>
                        {t("meets the expectations and/or needs of the user;")}
                      </li>
                      <li>
                        {t(
                          "is available at all times in whole or in part without disruption."
                        )}
                      </li>
                    </ol>
                  </li>

                  <li>
                    {t(
                      "Unless expressly stated otherwise, all content offered on the Service is non-binding information. The specific supply contract between the Provider and the User shall always be decisive."
                    )}
                  </li>
                  <li>
                    {t(
                      "The Provider shall only be liable for its own intent and gross negligence and for intent and gross negligence on the part of its legal representatives and vicarious agents. Liability for simple negligence is excluded, unless damages from injury to life, body or health are affected. These limitations of liability shall apply accordingly to the liability of legal representatives and vicarious agents."
                    )}
                  </li>
                </ol>
              </li>
              <li>
                <b>{t("Final Provisions")}</b>
                <ol>
                  <li>
                    {t(
                      "The law of the Federal Republic of Germany shall apply exclusively."
                    )}
                  </li>
                  <li>
                    {t(
                      "Should individual provisions of these Terms of Use be or become invalid or unenforceable, this shall not affect the validity of the remaining provisions."
                    )}
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={props.hideModal}>
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default TermsOfUseModal;
